<template>
  <div class="container">
    <div class="regard-home">
      <div class="regard-home-content regard-home-content-1">
        <!-- <div class="l-regard-view l-regard-view-1">
          <span class="l-rv-title">关于播聘</span>
          <div class="l-rv-content">用播聘好玩又赚钱</div>
        </div> -->

        <div class="relation">
          <div class="relation-body">
            <!-- <h3 class="relation-view relation-view-2">联系播聘</h3> -->
            <div class="relation-view relation-view-3">
              <div class="relation-view-list">
                <div class="relation-view-label">战略合作(商务/市场)</div>
                <div class="relation-view-value">{{ $config.email }}</div>
              </div>
              <div class="relation-view-list">
                <div class="relation-view-label">投诉与建议</div>
                <div class="relation-view-value">{{ $config.phone }}</div>
              </div>
              <div class="relation-view-list">
                <div class="relation-view-label">校园活动合作</div>
                <div class="relation-view-value">
                  {{ $config.adEmail }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyHome",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped="scoped">
@import url("./company-home.css");
</style>



// WEBPACK FOOTER //
// src/pages/company-home/company-home.vue